
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Tour Pages
const EveningDesertSafariPage = lazy(() => import('../pages/tours/evening-desert-safari/page'));
const VipDesertSafariPage = lazy(() => import('../pages/tours/vip-desert-safari/page'));
const MorningDesertSafariPage = lazy(() => import('../pages/tours/morning-desert-safari/page'));
const SunriseDesertSafariPage = lazy(() => import('../pages/tours/sunrise-desert-safari/page'));
const QuadBikeSafariPage = lazy(() => import('../pages/tours/quad-bike-safari/page'));
const DirtBikeAdventurePage = lazy(() => import('../pages/tours/dirt-bike-adventure/page'));
const DesertBuggyDubaiPage = lazy(() => import('../pages/tours/desert-buggy-dubai/page'));
const PremiumDesertSafariPage = lazy(() => import('../pages/tours/premium-desert-safari/page'));
const HalfDayDesertSafariPage = lazy(() => import('../pages/tours/half-day-desert-safari/page'));
const OvernightDesertSafariPage = lazy(() => import('../pages/tours/overnight-desert-safari/page'));
const PrivateDesertSafariPage = lazy(() => import('../pages/tours/private-desert-safari/page'));

import BookingPage from '../pages/booking/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/evening-desert-safari',
    element: <EveningDesertSafariPage />
  },
  {
    path: '/vip-desert-safari',
    element: <VipDesertSafariPage />
  },
  {
    path: '/morning-desert-safari',
    element: <MorningDesertSafariPage />
  },
  {
    path: '/sunrise-desert-safari',
    element: <SunriseDesertSafariPage />
  },
  {
    path: '/quad-bike-safari',
    element: <QuadBikeSafariPage />
  },
  {
    path: '/dirt-bike-adventure',
    element: <DirtBikeAdventurePage />
  },
  {
    path: '/desert-buggy-dubai',
    element: <DesertBuggyDubaiPage />
  },
  {
    path: '/premium-desert-safari',
    element: <PremiumDesertSafariPage />
  },
  {
    path: '/half-day-desert-safari',
    element: <HalfDayDesertSafariPage />
  },
  {
    path: '/overnight-desert-safari',
    element: <OvernightDesertSafariPage />
  },
  {
    path: '/private-desert-safari',
    element: <PrivateDesertSafariPage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
